module.exports = __webpack_public_path__ + "img/thumbnail_BighornSheep_j_normal.2529088c.png";